import { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { EMAIL_REGEX } from '../../../helpers/constants'
import { setFormFieldValue, validateFormField } from '../../../reducers/formReducer'

export class EmailField extends Component {
  constructor(props) {
    super(props)
    this.valueChange = this.valueChange.bind(this)
  }

  componentDidMount() {
    const { formType, fieldName, defaultValue } = this.props
    const initialValue = defaultValue || ''
    if (typeof formType !== 'undefined') {
      this.props.setFormFieldValue(formType, fieldName, initialValue)
      this.props.validateFormField(formType, fieldName, this.isValid(initialValue))
    }
  }

  componentWillReceiveProps(nextProps) {
    const { formType, fieldName, defaultValue } = this.props
    if (typeof formType !== 'undefined' && defaultValue !== nextProps.defaultValue) {
      this.props.setFormFieldValue(formType, fieldName, nextProps.defaultValue)
      this.props.validateFormField(formType, fieldName, this.isValid(nextProps.defaultValue))
    }
  }

  valueChange(e) {
    e.preventDefault()
    const { formType, fieldName, onChange } = this.props
    if (typeof formType !== 'undefined') {
      this.props.setFormFieldValue(formType, fieldName, e.target.value)
      this.props.validateFormField(formType, fieldName, this.isValid(e.target.value))
    }
    if (typeof onChange === 'function') {
      onChange(e)
    }
  }

  isValid(val) {
    return val.length > 0 && EMAIL_REGEX.test(val)
  }

  render() {
    const {
      form,
      formType,
      fieldName,
      label,
      placeholder,
      additionalClass,
      showErrorLabel,
      isDisabled,
      value,
    } = this.props
    return (
      <div className="field">
        <div className="control">
          {label && (
            <label htmlFor={fieldName} className="label">
              {label}
            </label>
          )}
          <input
            type="email"
            className={`input ${additionalClass}`}
            onChange={this.valueChange}
            value={typeof formType !== 'undefined' ? form[formType][fieldName].value : value}
            id={fieldName}
            name={fieldName}
            placeholder={placeholder}
            disabled={isDisabled}
          />
          {showErrorLabel && <label className="label--error">Email is invalid</label>}
        </div>
      </div>
    )
  }
}

EmailField.propTypes = {
  form: PropTypes.object,
  formType: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  additionalClass: PropTypes.string,
  setFormFieldValue: PropTypes.func,
  validateFormField: PropTypes.func,
  showErrorLabel: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.string,
}

export default connect(
  (state) => {
    return {
      form: state.form,
    }
  },
  { setFormFieldValue, validateFormField },
)(EmailField)
